import { FormattedMessage } from 'react-intl';
import styles from './styles.module.scss';
import { BenefitItem } from '@/widgets/HomePage/Benefits/BenefitItem';
import { benefits } from '@/widgets/HomePage/Benefits/model';

const Benefits = () => {
  return (
    <section className="section">
      <div className="container">
        <h2 className={styles.title}>
          <FormattedMessage defaultMessage="Онлайн сервис для легкого получения микрокредита в кратчайший срок!" />
        </h2>
        <div className={styles.contentBlock}>
          {benefits.map(({ number, title, subtitle }) => (
            <BenefitItem
              key={number}
              number={number}
              title={title}
              subtitle={subtitle}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
